(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/skeleton/route-my-bets-wager-fallback-bomben.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/skeleton/route-my-bets-wager-fallback-bomben.js');
"use strict";

const {
  SkeletonLine
} = svs.components.lbUi;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const {
  WagerSkeleton
} = svs.components.tipsen.modularBase;
const {
  clx
} = svs.components.lbUtils;
const RouteWagerCouponFallback = _ref => {
  let {
    isSmallScreen
  } = _ref;
  return React.createElement("div", {
    className: clx('coupon-match-skeleton coupon-match-skeleton-bomben', {
      'coupon-match-skeleton-bomben-small-screen': isSmallScreen
    })
  }, React.createElement("div", {
    className: "coupon-match-team-skeleton-team-header"
  }, React.createElement(SkeletonLine, {
    className: "coupon-match-team-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-team-skeleton"
  })), React.createElement("div", {
    className: "coupon-match-sub-team-skeleton"
  }, React.createElement(SkeletonLine, {
    className: "coupon-match-team-skeleton"
  })), React.createElement("div", {
    className: "coupon-match-signs"
  }, Array.from({
    length: 10
  }).map((_, i) => {
    const key = "coupon-sign-home-".concat(i);
    return React.createElement(SkeletonLine, {
      className: "coupon-match-sign-skeleton",
      key: key
    });
  })), React.createElement("div", {
    className: "coupon-match-sub-team-skeleton"
  }, React.createElement(SkeletonLine, {
    className: "coupon-match-team-skeleton"
  })), React.createElement("div", {
    className: "coupon-match-signs"
  }, Array.from({
    length: 10
  }).map((_, i) => {
    const key = "coupon-sign-away-".concat(i);
    return React.createElement(SkeletonLine, {
      className: "coupon-match-sign-skeleton",
      key: key
    });
  })));
};
const RouteMyBetsWagerFallbackBomben = () => {
  const isSmallScreen = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  return React.createElement(WagerSkeleton, null, React.createElement(WagerSkeleton.DrawCard, null), React.createElement(WagerSkeleton.Coupon, null, React.createElement("div", {
    className: "pg_my_bets_wager_fallback__grid__coupon__grid"
  }, Array.from({
    length: 3
  }).map((_, i) => {
    const key = "coupon-".concat(i);
    return React.createElement(RouteWagerCouponFallback, {
      isSmallScreen: isSmallScreen,
      key: key
    });
  }))), React.createElement(WagerSkeleton.SideNav, null), React.createElement(WagerSkeleton.ResultCard, null), React.createElement(WagerSkeleton.WinGroups, {
    numberOfWinGroups: 1
  }), React.createElement(WagerSkeleton.Receipt, null), React.createElement(WagerSkeleton.Buttons, null));
};
setGlobal('svs.components.tipsen.modularBase.RouteMyBetsWagerFallbackBomben', RouteMyBetsWagerFallbackBomben);

 })(window);